import React, { useState } from 'react';
import axios from 'axios';
import './Adminregister.css';
import config from '../../config/config';

const Adminregister = () => {
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');

  const [errors, setErrors] = useState({});
  const [passwordStrength, setPasswordStrength] = useState('');

  const checkPasswordStrength = (pwd) => {
    if (pwd.length < 6) return 'Not Secure';
    if (pwd.match(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,}$/)) return 'Medium';
    if (pwd.match(/^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/)) return 'Strong';
    return 'Not Secure';
  };

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
    const strength = checkPasswordStrength(pwd);
    setPasswordStrength(strength);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    const allowedDomains = ['gmail.com', 'yahoo.com', 'hotmail.com'];
  const getDomainFromEmail = (email) => {
    const parts = email.split('@');
    return parts.length === 2 ? parts[1].toLowerCase() : '';
  };

    if (!fullname.trim()) newErrors.fullname = 'Full Name is required';
    if (!email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
    newErrors.email = 'Invalid Email Format';
  } else if (!allowedDomains.includes(getDomainFromEmail(email))) {
    newErrors.email = 'Only Gmail, Yahoo, or Hotmail emails are allowed';
  }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (passwordStrength === 'Not Secure') {
      newErrors.password = 'Password is too weak';
    }

    if (!confirmpassword) {
      newErrors.confirmpassword = 'Confirm Password is required';
    } else if (password !== confirmpassword) {
      newErrors.confirmpassword = 'Passwords do not match';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      const response = await axios.post(`${config.apiBaseUrl}/api/admin/register`, {
        fullname,
        email,
        password,
      });

      alert('Registration Successful!');
      setFullname('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setPasswordStrength('');
      setErrors({});
    } catch (error) {
      console.error(error);
      if (error.response?.data?.error) {
        const message = error.response.data.error;
        if (message.includes('Email already registered')) {
          setErrors({ email: message });
        } else {
          setErrors({ general: message });
        }
      } else {
        setErrors({ general: 'Registration failed!' });
      }
    }
  };

  return (
    <div className="admin-register-container">
      <div className="admin-register-box">
        <h2 className="admin-register-title">ADMIN Register</h2>
        <form className="admin-register-form" onSubmit={handleSubmit}>
          <div className="input-group">
            {errors.fullname && <p className="error">{errors.fullname}</p>}
            <input
              type="text"
              placeholder="Full Name"
              className="admin-input"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
            />
          </div>

          <div className="input-group">
            {errors.email && <p className="error">{errors.email}</p>}
            <input
              type="email"
              placeholder="Email"
              className="admin-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="input-group">
            {errors.password && <p className="error">{errors.password}</p>}
            <input
              type="password"
              placeholder="Password"
              className="admin-input"
              value={password}
              onChange={handlePasswordChange}
            />
            {password && (
              <p className={`strength ${passwordStrength.toLowerCase().replace(' ', '-')}`}>
                Strength: {passwordStrength}
              </p>
            )}
          </div>

          <div className="input-group">
            {errors.confirmpassword && <p className="error">{errors.confirmpassword}</p>}
            <input
              type="password"
              placeholder="Confirm Password"
              className="admin-input"
              value={confirmpassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          {errors.general && <p className="error">{errors.general}</p>}

          <button type="submit" className="admin-register-button">Register</button>
        </form>
      </div>
    </div>
  );
};

export default Adminregister;
